import React from 'react'
import { Toast } from '@vibe/core'

interface VibeToastProps {
  open: boolean
  type: 'positive' | 'negative' | 'warning'
  message: string
  onClose: () => void
  autoHideDuration?: number
  className?: string
}

export const VibeToast: React.FC<VibeToastProps> = ({
  open,
  type,
  message,
  onClose,
  autoHideDuration = 5000,
  className = 'fixed top-4 right-4 z-50',
}) => {
  if (!open) return null

  return (
    <Toast
      open={open}
      type={type}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      className={className}
    >
      {message}
    </Toast>
  )
}

export default VibeToast
